import React from 'react';

import classnames from 'classnames';

import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import MenuDropdown from '@hydra/common/components/Header/MenuDropdown';
import menuItems from '@hydra/common/components/Header/menuItems';

import { useI18n } from '@hydra/common/customHooks';

import getTranslatedUrl, { UrlType } from '@hydra/utils/getTranslatedUrl';

const useStyles = makeStyles(theme => ({
  item: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(1.125, 1),
    border: '2px solid transparent',
    '&:first-child': {
      marginLeft: theme.spacing(4)
    },
    '&:hover': {
      backgroundColor: 'unset',
      borderBottomColor: theme.palette.primary.main
    }
  },
  helpDropdownButton: {
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.grey[900]
  },
  mobileHidden: {
    [theme.breakpoints.down(1100)]: {
      display: 'none'
    }
  }
}));

export default function NavigationContainer () {
  const classes = useStyles();
  const { locale } = useI18n();

  return (
    <div className={classes.mobileHidden} data-testid='navigation-container'>
      {
        menuItems.map((menu, index) => menu.group
          ? menu.items && (
            <MenuDropdown
              key={index}
              contentColor='gray'
              menuItems={menu.items}
              renderTrigger={({ ...props }) => (
                <Button
                  {...props}
                  className={classes.item}
                >
                  <Typography noWrap className={classes.helpDropdownButton}>
                    <Translate content={menu.label} />
                  </Typography>
                </Button>
              )}
            />
            )
          : menu.link && (
            <Button key={index} className={classnames(classes.item, menu.className)} href={getTranslatedUrl(menu.link as UrlType, locale)}>
              <Typography noWrap className={classes.helpDropdownButton}>
                <Translate content={menu.label} />
              </Typography>
            </Button>
          )
        )
      }
    </div>
  );
}
